import { render, staticRenderFns } from "./Options.vue?vue&type=template&id=8ea99742&"
import script from "./Options.vue?vue&type=script&lang=js&"
export * from "./Options.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8ea99742')) {
      api.createRecord('8ea99742', component.options)
    } else {
      api.reload('8ea99742', component.options)
    }
    module.hot.accept("./Options.vue?vue&type=template&id=8ea99742&", function () {
      api.rerender('8ea99742', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/emails/components/suppressed/Options.vue"
export default component.exports